export const HeaderNav = [
    {
        content:"Home",
        link:'/',
    },
    {
        content:"About",
        link:'/about',
    },
    {
      content:"Why Teific",
      link:'/whyteific',
  },
    {
        content:"Contact Us",
        link:'/contact',
    },
   
];


export const HomePageContent = [
    {
        id:1,
        bgText:"Customized Drones",
        heading:"Customized Drones",
        content:"Soar above the ordinary with our tailor-made drones. Our team of expert’s crafts drones that cater  to your specific needs, whether it's for aerial photography, industrial inspections, or personal  exploration. From advanced features to robust designs, our drones are designed to deliver exceptional  performance and reliability.",
        imageUrl:"",

    },
    {
        id:2,
        bgText:"Smart Healthcare",
        heading:"Smart Healthcare Devices",
        content:"Revolutionize healthcare with our innovative smart devices. Our cutting-edge technology empowers individuals to monitor their health, manage chronic conditions, and improve overall well being. From wearable devices to home healthcare solutions, our products offer convenience, accuracy, and personalized care. ",
        imageUrl:require("../Assets/images/AmbuLifeImg.png"),

    },
    {
        id:3,
        bgText:"Smart Healthcare",
        heading:"Custom Product Design",
        content:"Bring your vision to life with our expert product design services. Our team of skilled designers specializes in creating customized electrical and electronics products that meet your exact requirements. From concept development to prototyping and  manufacturing, we provide end-to-end solutions tailored to your needs. ",
        imageUrl:"",

    },
];


export const FooterData = [
   
    {
      title: "Partnership",
      links: [
        { name: "Ambuvians", url: "https://ambuvians.in/" },
      ],
    },
    {
      title: "Support",
      links: [
        { name: "FAQs", url: "/contact#section1" },
        { name: "Help & Support", url: "/contact#section1" },
      ],
    },
    {
      title: "Company",
      links: [
       
        { name: "Careers", url: "/contact#section1" },
     
      ],
    },
  ];


  export const LeadershipTeam = [
    {
      index: 1,
      imageUrl: require('../Assets/images/Muzammil 1.png'),
      name: "Muzammil",
      designation: "Product Designer",
      flag: false,
      link: "https://www.linkedin.com/in/mohammad-muzammil-023088273/"
    },
    {
      index: 2,
      imageUrl: require('../Assets/images/Kumudshekhar Sharma 1.png'),
      name: "Kumudshekhar",
      designation: "Team Lead",
      flag: false,
      link: "https://www.linkedin.com/in/kumudshekhar-sharma/"
    },
    {
      index: 3,
      imageUrl: require('../Assets/images/Harsh Jain 2.png'),
      name: "Harsh Jain",
      designation: "Manager",
      flag: false,
      link: "https://www.linkedin.com/in/harsh-jain-%F0%9F%87%AE%F0%9F%87%B3-5792a0272/"
    },
    {
      index: 4,
      imageUrl: require('../Assets/images/Prerit Rastogi 1.png'),
      name: "Prerit Rastogi",
      designation: "Marketing Manager",
      flag: false,
      link: "https://www.linkedin.com/in/prerit-rastogi-7042b0289/"
    },
    {
      index: 5,
      imageUrl: require('../Assets/images/Aryan Saini 1.png'),
      name: "Aryan Saini",
      designation: "Hardware Manager",
      flag: false,
      link: "https://www.linkedin.com/in/aryan-saini-%F0%9F%87%AE%F0%9F%87%B3-959957269/"
    }
  ];
  
  export const MentorTeam = [
    {
      index: 1,
      imageUrl: require('../Assets/images/Dr. Neeraj Kumar Gupta 1.png'),
      name: "Dr. Neeraj Kumar Gupta",
      designation: "Mentor",
      flag: true,
      link: "https://www.linkedin.com/in/dr-neeraj-kumar-gupta-a4977096/"
    },
    {
      index: 2,
      imageUrl: require('../Assets/images/Mr. Salim 1.png'),
      name: "Mr. Salim",
      designation: "Mentor",
      flag: true,
      link: "https://www.linkedin.com/in/salim-116b721a/"
    },
    {
      index: 3,
      imageUrl: require('../Assets/images//Dr. Arvind K. Sharma 1.png'),
      name: "Dr. Arvind K. Sharma",
      designation: "Mentor",
      flag: true,
      link: "https://www.linkedin.com/in/dr-arvind-kumar-sharma-a8138549/?originalSubdomain=in"
    }
  ];
  